<template>
  <span
    :class="{ active: selected, empty: rating.percent == 0 }"
    rel="nofollow"
    class="rating-bar"
    v-bind="$attrs"
  >
    <translate class="percentage" :tt="{ rate: rating.percent / 100 }"
      >{rate, number, percent}</translate
    >
    <div class="graph-bar">
      <span class="rating" :style="{ height: rating.percent + '%' }" />
    </div>
    <span class="label">{{ rating.rate }}</span>
  </span>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { Rating } from '../types'

@Component
class RatingsDistributionBar extends Vue {
  @Prop()
  selected: boolean

  @Prop()
  rating: Rating

  async mounted() {
    await this.$nextTick()
    setTimeout(() => {
      this.$el.classList.add('loaded')
    }, 150)
  }
}

export default toNative(RatingsDistributionBar)
</script>

<style scoped>
.rating-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--colour-text-light);
  padding: 0.1em;
  border: 2px solid transparent;
  border-radius: 0.3em;
}

.rating-bar.active {
  border-color: var(--colour-light-blue);
  color: var(--colour-text-default);
}

.graph-bar {
  background-color: #eef6fa;
  border-radius: 0.15em;
  flex: 0 0 4em;
  min-width: 0.8em;
  position: relative;
  margin: 0.5em 0;
}

.rating {
  background-color: var(--colour-orange);
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0.15em;
  height: auto;
  opacity: 0;
  transition: all 0.6s ease-in-out;
}

.loaded .rating {
  opacity: 1;
  height: auto;
}

.percentage {
  font-size: smaller;
  line-height: 1;
}

.label {
  color: var(--colour-text-default);
}

.empty {
  cursor: default;
}

@media (hover: hover) {
  .graph-bar:hover {
    filter: brightness(0.85);
  }
}
</style>
